export async function searchLogos(query, { num = 8 } = {}) {
  try {
    const q = `${query} logo transparent png`;
    const url = `/api/images/google?q=${encodeURIComponent(q)}&num=${encodeURIComponent(num)}`;
    const r = await fetch(url);
    if (!r.ok) throw new Error('http');
    return await r.json();
  } catch {
    return [];
  }
}
